import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { GtmService } from 'src/app/shared/services/gtm.servie';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-sokusai-register-send',
  templateUrl: './sokusai-register-send.component.html',
  styleUrls: ['../style/global.css', './sokusai-register-send.component.css'],
})
export class SokusaiRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  initialized = false;
  gtmService: GtmService;
  constructor(private title: Title, gtmService: GtmService) {
    super();
    this.gtmService = gtmService;
  }

  ngOnInit(): void {
    const gtmId = environment.apps[this.clientId].gtm?.id;
    if (gtmId) {
      this.gtmService.setGtmId(gtmId);

      this.gtmService.addGtmToDom();
    }
    this.title.setTitle(`認証用URL送信完了 | ${this.pageTitle}`);
    setTimeout(() => {
      this.initialized = true;
    }, 1000);
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId]?.type);
  }

  get pageTitle() {
    return environment.apps[this.clientId]?.pageTitle || '';
  }

  get oemId() {
    return environment.apps[this.clientId]?.oemConfig?.id;
  }
}
